import { Link } from "react-router-dom";

import Button from "../../components/elements/button";
import "./index-not-found.css";

export default function NotFound() {
  return (
    <div className="ep-not-found-page">
      <main className="ep-not-found">
        <div className="ep-not-found-inner">
          <div className="ep-404-art" aria-label="Erro 404">
            <span className="ep-404-number">4</span>
            <span className="ep-404-number">0</span>
            <span className="ep-404-number">4</span>
            <span className="ep-404-pencil" aria-hidden="true" />
          </div>
          <div className="ep-service-eyebrow">Ops! Página não encontrada</div>
          <h1>Parece que essa página saiu da redação.</h1>
          <p>
            O endereço pode ter sido alterado ou digitado incorretamente. Mas
            podemos ajudar você a encontrar o caminho de volta.
          </p>
          <div className="ep-not-found-actions">
            <Link to="/">
              <Button>Voltar para o início</Button>
            </Link>
            <Link to="/modalidades">
              <Button>Ver modalidades</Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}